
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.278 1.278v8.944h8.944V5.75H11.5v4.472c0 .703-.575 1.278-1.278 1.278H1.278C.568 11.5 0 10.925 0 10.222V1.278C0 .575.569 0 1.278 0H5.75v1.278H1.278zm5.75 0V0H11.5v4.472h-1.278V2.18l-6.28 6.28-.9-.9 6.28-6.281H7.027z","fill":"#585858"}})])
          )
        }
      }
    